import LoanDashboardIndexScreen from "@/screens/loans/LoanDashboardIndexScreen"

export default function LoansScreen() {
  return <LoanDashboardIndexScreen />
}
